import { render, staticRenderFns } from "./BatteryIcon.vue?vue&type=template&id=caeb2938&scoped=true&"
import script from "./BatteryIcon.vue?vue&type=script&lang=js&"
export * from "./BatteryIcon.vue?vue&type=script&lang=js&"
import style0 from "./BatteryIcon.vue?vue&type=style&index=0&id=caeb2938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caeb2938",
  null
  
)

export default component.exports